import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as BsArrowRight } from "../../assets/Icons/Universal/BsArrowRight.svg";
import "../../styles/ComponentsStyles/Universal/GuideCard.style.css";
import { useNavigate } from "react-router-dom";

const GuideCard = ({ title, description, image, link }) => {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate(link)} className="UniversalGuidCard">
      <div className="left">
        <h4 className="title">
          {title}
          <BsArrowRight />
        </h4>
        <p className="description">{description}</p>
      </div>
      <div className="right">
        <img src={image} alt={title} />
      </div>
    </div>
  );
};

GuideCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default GuideCard;
